/**
 * `EntitlementMode`, `ResolvedFeature` e `PlanEntitlements` moraram aqui;
 * agora moram em `@tami/core/entitlements`, reexportados para os
 * importadores existentes seguirem intactos.
 */
export type { EntitlementMode, PlanEntitlements, ResolvedFeature } from "@tami/core";
/**
 * `Plan` e `PLAN_CYCLE` moraram aqui; agora moram em `@tami/core/billing`
 * (schema + normalização), reexportados para os importadores existentes
 * seguirem intactos.
 */
export { PLAN_CYCLE, type Plan } from "@tami/core";
/** Morava aqui como literal solto; agora é o contrato do corpo do checkout. */
export type { PlanAudience } from "@tami/contracts";

export enum PLAN_STATUS {
  CREATED = "CREATED",
  TRIAL = "TRIAL",
  ACTIVE = "ACTIVE",
  CANCELED = "CANCELED",
  PAYMENT_WAIT = "PAYMENT_WAIT",
  PAYMENT_FAILED = "PAYMENT_FAILED",
}
